<template>
  <!-- :style="{backgroundImage:'url('+ bg +')'}"  -->
  <div class="page">
    <new-group></new-group>
     
    <div class="container">
      <keti-header></keti-header>
      <div :style="isLasp?{}:{padding:'0 24px'}">
        <side-bar :mode="mode" :menus="menus" :active-menu="activeMenu" v-if="!isLasp"></side-bar>
      </div>
      <div class="lasp">
        <div class="lasp-left" v-if="isLasp">
          <side-bar :mode="mode" :menus="menus" :active-menu="activeMenu"></side-bar>
        </div>
        <div class="lasp-right">
          <ki-breadcrumb v-if="isLasp"></ki-breadcrumb>
          <div class="lasp-right-content" v-if="isLasp">
            <router-view></router-view>
          </div>
          <div v-if="!isLasp" class="kt-i-content">
            <router-view></router-view>
          </div>
        </div>
      </div>
       <keti-footer></keti-footer>
    </div>
  </div>
</template>
 
<script>
/**
  * @name  (组件名称)
  * @module 组件存放位置
  * @desc 组件描述
  * @author Jacke
  * @date
  * @param {Object} [title]    - 参数说明
  * @param {String} [columns] - 参数说明
  * @example 调用示例
  *  <></>
  */
import KetiHeader from './header'
import KetiFooter from './footer.vue'
import SideBar from './sideBar.vue'
import KiBreadcrumb from './breadcrumb.vue'
import router from "@/router";
import NewGroup from "@/lasp/newGroup.vue";

export default {
  name: 'Layout',
  components: {
    KetiHeader,
    KetiFooter,
    SideBar,
    KiBreadcrumb,
    NewGroup
  },
  props: {},
  data() {
    return {
      bg: require("@/assets/img/bg001.png"),
      mode:'vertical',
      menus:[],
      isLasp:true,
      activeMenu:''
    }
  },
  created() {
  },
  mounted() {
    this.updateMenu(this.$route, null)
  },
  methods: {
    updateMenu(to, from) {
      console.log('to', to)
      let that = this
      let routes = router.options.routes
      if (to.path.startsWith('/lasp')) {
        that.isLasp = true
        that.mode = 'vertical'
        that.menus = routes.find(e => e.name === 'Lasp').children.filter(e=>!e.meta.hide)
        /**
         * $store来自Store对象
         * dispatch 向 actions 发起请求
         */

      } else if (to.path.startsWith('/introduce')) {
        that.isLasp = false
        that.mode = 'horizontal'
        that.menus = routes.find(e => e.name === 'Introduce').children.filter(e=>!e.meta.hide)
      }
      // let index = this.menus.findIndex(e=>e.name == to.name)
      this.$nextTick(() => {
        this.activeMenu = to.name
      })
      console.log('activeMenu', this.activeMenu)
      let index = this.menus.findIndex(e => e.name == to.name)
      console.log('index', index)
    }
  },
  computed: {},
  watch: {
    '$route': 'updateMenu'
  }
}
</script>

<style lang="less" scoped>
.page {
  overflow-y: auto;
  width: 100vw;
  min-height: 100vh;
  //background: #f4f5fd;
  //background: #f5f7fa;
  //background: #f1f1f1;
  background: #f5f5f5;
  // background:linear-gradient(to right, #bb313e25, #bb313e25, #d7222925, #dd4a1625, #e4761525, #f5c50025, #f0e92725, #b1ce2425, #48a93525, #03944525, #157c4f25, #176a5825, #1b556325, #1d386f25, #1d386f25, #20277825, #52266325, #8a244b25);
  // background-image: linear-gradient(191deg,rgba(238,255,247,.36),#f4f5fd,rgba(189,233,255,.21),#f4f5fd);
  // background-image: linear-gradient(191deg,rgba(238,255,247,.36),rgba(97,211,255,.32),rgba(189,233,255,.21),rgba(97,206,236,.43));
}

.container {
  width: 1200px;
  margin: 0 auto;
  // overflow: inherit;
  // overflow-y: auto;
  // overflow-x: hidden;
}

.lasp {
  width: 100%;
  display: flex;
  // display;
  .lasp-left {
    //width: 220px;
  }

  .lasp-right {
    width: 1180px;
  }

  .lasp-right-content {
    padding: 24px 24px;
  }
}
.kt-i-content{
  padding: 24px 0 24px 24px;
}
</style>



// WEBPACK FOOTER //
// src/layout/layout.vue